import { OrientationType, SideOfRoadType } from 'app/models/enums';

import { OpenLRLastLocationReferencePoint } from './openlrlastlocationreferencepoint.model';
import { OpenLRLocationReferencePoint } from './openlrlocationreferencepoint.model';

export class OpenLRPointAlongLine {
  openlrPositiveOffset: number;
  openlrOrientation: OrientationType;
  openlrLastLocationReferencePoint: OpenLRLastLocationReferencePoint;
  openlrLocationReferencePoint: OpenLRLocationReferencePoint;
  openlrSideOfRoad: SideOfRoadType;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrpointalongline.model.ts